module.exports = __webpack_public_path__ + "img/sharc-imageplaceholder-light.7824bcd7.jpg";